import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ListingReportsEvent from 'components/ListingReportsEvent';
import { api } from 'services';

//Nome do evento | Categoria | Data | Valor orçado | Valor real |  Valor captado

const Events = () => {
  const defaultFilters = {
    search: '',
    per_page: 10,
    page: 1,
    type_task: '',
    start_date: '',
    end_date: '',
  };

  const [filters, setFilters] = useState(defaultFilters);
  const [reports, setReports] = useState({ data: [] });
  const [typeTasks, setTypeTasks] = useState([]);
  const [load, setLoad] = useState(true);

  const { t } = useTranslation();

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) {
      f = { ...defaultFilters, ...new_filters };
    }

    setFilters(f);
  };

  useEffect(() => {
    api
      .get('task-groups/list-for-event')
      .then(({ data }) => setTypeTasks(data[0].tasks));
  }, []);

  useEffect(() => {
    setLoad(true);
    api.get('events-report', {
      params: {
        ...filters,
      },
    })
    .then(({ data: response }) => {
      setReports(response);        
    })
    .finally(() => setLoad(false));
  }, [filters]);

  return (
    <>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
          <Col>
            <h4>{t('title:events report')}</h4>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Row>
              <Col>
                <ReactHTMLTableToExcel
                  id="event-report-table-btn"
                  className="btn btn-dark btn-sm"
                  sheet="Report Event"
                  filename="Report Event"
                  table="event-report-table"
                  buttonText={t('label:export')}
                ></ReactHTMLTableToExcel>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <ListingReportsEvent
                  reports={reports}
                  filters={[]}
                  typeTasks={typeTasks}
                  stateFilters={setFilters}
                  handleFilterChange={handleFilterChange}
                  load={load}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  );
};

export default MasterPage(Events);
